
import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import oBrokerPreview from '@/components/organisms/broker/BrokerPreview.vue';
import oBrokerMapCard from '@/components/organisms/broker/BrokerMapCard.vue';
import mLoader from '@/components/molecules/Loader.vue';
import Format from '@/functions/format';
import { EventBus } from '@/functions/eventBus';

interface Texts {
    heading: string;
    noResultsHeading: string;
    resetButtonText: string;
    brokerLinksText: string;
    brokerLinksUrl: string;
}

export default {
    components: {
        oBrokerPreview,
        oBrokerMapCard,
        mLoader,
    },

    props: {
        texts: {
            type: Object as PropType<Texts>,
            default: () => ({
                heading: '',
                noResultsHeading: '',
                resetButtonText: '',
                brokerLinksText: '',
                brokerLinksUrl: '',
            }),
        },
    },

    computed: {
        ...mapGetters({
            activeBroker: 'brokerSearch/activeBroker',
            brokers: 'brokerSearch/results',
            totalCount: 'brokerSearch/totalCount',
            isLoading: 'brokerSearch/isLoading',
            view: 'brokerSearch/view',
        }),

        /**
         * Format count string.
         *
         * @return {string}
         */
        countText(): string {
            return this.texts.heading.replace(
                '#resultater#',
                Format.amount(this.totalCount),
            );
        },

        isMobile(): Boolean {
            return !EventBus.isDesktop;
        },
    },

    methods: {
        ...mapActions({
            setBrokerQuery: 'brokerSearch/setQuery',
        }),

        /**
         * Zoom out on map and reset filters.
         *
         * @return {void}
         */
        zoomOutAndReset(): void {
            this.setBrokerQuery('');
            EventBus.$emit('brokerSearch.reset');
        },
    },
};
